// Only used for production builds
require('../../../reportum-ui/dist/classic.js');
